import React, { useEffect, useState } from 'react'
import { deepFind } from 'react-children-utilities'
import { usePopper } from 'react-popper'

const Trigger = () => null
const Content = () => null

const Popover = ({ children, visible, options, width, display='block', placement='bottom-start' }) => {

	const trigger = deepFind(children, child => child.type === Trigger)
	const content = deepFind(children, child => child.type === Content)

	const [referenceElement, setReferenceElement] = useState(null)
	const [popperElement, setPopperElement] = useState(null)
	const { styles, attributes, update } = usePopper(referenceElement, popperElement, { placement, ...options })

	useEffect(() => {
		if (visible && update) {
			update().catch(error => {
				console.error('Failed to update popper:', error);
			});
		}
	}, [visible, update]);

	return (
		<>
			<div className="popover-trigger" style={{ display: display }} ref={setReferenceElement}>
				{ trigger && trigger.props.children }
			</div>

			{ visible &&
				<div ref={setPopperElement} className="popover-element" style={styles.popper} {...attributes.popper}>
					{ content && content.props.children }
				</div>
			}
		</>
	)
}

Popover.Trigger = Trigger
Popover.Content = Content

export default Popover
